var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-design-artists-view"
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acc206da","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ProductDesignArtistsView.vue
// module id = 2094
// module chunks = 0